// src/services/sharedMachine.js — "this is not my computer", remembered.
//
// 🟢 ONE QUESTION AT PAIRING BEATS A TIMER FOR EVERYBODY. The library computer
//    is the case a global idle logout is reaching for, and it is the only case
//    it serves — everyone on their own laptop just gets interrupted. Asked once,
//    the answer is better than the guess: this machine gets short caps, no
//    history written to its disk, and a wipe when the tab closes.
//
// 🟥 THE FLAG LIVES IN sessionStorage, NOT localStorage, ON PURPOSE. localStorage
//    survives the tab — and a "shared machine" marker that outlives the session
//    it describes would silently apply to the NEXT person who signs in here.
//    sessionStorage dies with the tab, which is exactly the lifetime of the
//    claim being made.

const KEY = 'allo_shared_machine';

export function markShared(on) {
  try {
    if (on) sessionStorage.setItem(KEY, '1');
    else sessionStorage.removeItem(KEY);
  } catch { /* private mode — isShared() then reads false, which is the safe way round */ }
}

/**
 * 🟥 SAFE DIRECTION MATTERS HERE AND IT IS NOT THE OBVIOUS ONE. If storage is
 *    unreadable we answer FALSE — not shared — because the alternative is
 *    wiping a private machine's history on every tab close for a claim we
 *    cannot actually confirm anybody made. The session document is the record
 *    of record; this is only the local shortcut to it.
 */
export function isShared() {
  try { return sessionStorage.getItem(KEY) === '1'; } catch { return false; }
}

/**
 * Erase everything when the tab goes, for a machine that is not ours.
 *
 * 🟥 `pagehide`, NOT `beforeunload`. beforeunload does not fire on mobile Safari
 *    when a tab is discarded and is unreliable on backgrounded tabs generally —
 *    it is the event people reach for and the one that does not run. `pagehide`
 *    fires on the paths that actually end a page.
 *
 * 🟥 AND `persisted` IS THE WHOLE POINT OF READING IT. A page going into the
 *    back/forward cache fires pagehide too, and is coming BACK — wiping there
 *    would erase a live session because somebody tapped Back.
 */
export function wipeOnClose(wipe) {
  const onHide = (e) => {
    if (!isShared()) return;
    if (e && e.persisted) return;   // bfcache: this page is returning
    try { wipe(); } catch { /* the tab is going anyway */ }
  };
  window.addEventListener('pagehide', onHide);
  return () => window.removeEventListener('pagehide', onHide);
}
